import type { WeightEntry } from "./types";

export type EntriesResult =
	| { ok: true; entries: WeightEntry[] }
	| { ok: false; unauthorized: true }
	| { ok: false; unauthorized: false; error: string };

interface EntriesRequestMessages {
	failure: string;
	conflict?: string;
}

// Every /api/entries* call from the app follows the same shape: send the
// request, recognize the backend's three response cases (401, 409, ok), and
// hand back a result instead of throwing. Centralizing this here means each
// caller in main.ts only has to say what's different — the URL, the method,
// and its own error wording.
export async function requestEntries(
	url: string,
	init: RequestInit,
	messages: EntriesRequestMessages,
): Promise<EntriesResult> {
	try {
		const res = await fetch(url, init);
		if (res.status === 401) return { ok: false, unauthorized: true };
		if (messages.conflict && res.status === 409) {
			return { ok: false, unauthorized: false, error: messages.conflict };
		}
		if (!res.ok) return { ok: false, unauthorized: false, error: messages.failure };
		const data = (await res.json()) as { entries: WeightEntry[] };
		return { ok: true, entries: data.entries };
	} catch (e) {
		return { ok: false, unauthorized: false, error: e instanceof Error ? e.message : "Something went wrong." };
	}
}
